import React from 'react';
import { Box, } from '@mui/material';
import { formatDateLong } from '../../../services/apiServices';
import { HtmlContentRenderer } from '../../../services/CommonServices';



const tableStyles = {
    border: '1px solid black',
    padding: '8px',
};

const CommercialInvoiceContentFirst = ({ amountInWords, commercialInvoiceNo, invoiceData, totalQty, amountData, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const reference = invoiceData?.reference || "";
    const manufacturerName = invoiceData?.manufacturerName || "";
    // Payment Terms from Proforma Invoice

    const rawAdvance = invoiceData?.ProformaInvExp?.advance;
    const rawFinal = invoiceData?.ProformaInvExp?.final;
    const rawCreditDay = invoiceData?.ProformaInvExp?.creditDay;

    const advance = rawAdvance ? `${rawAdvance}%` : '';
    const final = rawFinal ? `${rawFinal}%` : '';
    const creditDay = rawCreditDay ? `${rawCreditDay} Day` : '';
    const paymentAgainstTitle = invoiceData?.ProformaInvExp?.paymentAgainst?.title || '';

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const ibanNumber = companyBanks?.ibanNumber || '';

    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        qty: particular.qty || 0,
        amounts: particular.amount || 0,
        description: particular.description || 0,
        rate: `${currencySymbol} ${parseFloat(particular.rate).toFixed(2)}`,
        amount: `${currencySymbol} ${parseFloat(particular.amount).toFixed(2)}`,
        unitName: particular.productsUnit.unitName,
        // productName: particular.products.productName,
        productName: (
            <div style={{ display: 'block', }}>
                <div>
                    {particular.products.productName || '-'}
                </div>

                {particular.products.iupac && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>IUPAC :</strong> {particular.products.iupac}
                    </div>
                )}

                {particular.products.casNo && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>CAS No :</strong> {particular.products.casNo}
                    </div>
                )}
            </div>
        ),

    }));
    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{
                    position: 'relative',
                    padding: '0px', marginTop: footer ? '0px' : '50px',
                }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>Commercial Invoice</p>
                    </div>
                </div>
                <table
                    border='1px solid ##8c8b8b'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A', marginTop: "10px", marginBottom: "10px" }}
                >
                    <thead style={{ textAlign: 'left', backgroundColor: "#ededed" }} >
                        <tr>
                            <th colSpan={6}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontWeight: "500" }}>
                                    <div><span>order No:</span>{reference} </div>
                                    <div><span>C/I No:</span> <span style={{ textTransform: "uppercase" }}> {commercialInvoiceNo} </span></div>
                                    <div><span>date:</span> {invoiceDate}</div>
                                    <div><span></span> </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                </table>

                {/* Buyers and Sellers Info */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div style={{ width: '60%', }}>
                        <p style={{ margin: 1 }}><span>Buyer,</span></p>
                        <p style={{ margin: 1 }}>
                            <strong>{customerName}</strong>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>
                                {billingStreet && `${billingStreet},`}
                                <br />
                                {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                {billingPincode && ` - ${billingPincode}`}
                            </span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Email:</span> <span>{customerEmail}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Mobile:</span> <span>{customerMobile}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >IEC no:</span> <span>{iecNumber}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >GST no:</span> <span>{gstNumber}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >PAN no:</span> <span>{panNumber}</span>
                        </p>
                    </div>

                    <div style={{ width: '40%' }}>
                        <p style={{ margin: 1 }}><span>Seller,</span></p>
                        <p style={{ margin: 1 }}>
                            <strong>{companyName}</strong>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>
                                {companyAddress && `${companyAddress},`} <br />
                                {[companyCity, companyState, companyCountry].filter(Boolean).join(', ')}
                                {companyPincode && ` - ${companyPincode}`}
                            </span>

                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Email:</span> <span>{companyEmail}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Mobile:</span> <span>{companyMobile}</span>
                        </p>

                    </div>

                </div>

                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead style={{ backgroundColor: "#ededed" }}>
                        <tr>
                            <th style={{ textAlign: 'center', width: "5%" }}>Sn.</th>
                            <th style={{ textAlign: 'center', width: "45%" }}>Product Name</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "15%" }}>Rate</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Unit</th>
                            <th style={{ textAlign: 'center', width: "15%" }}>Amount</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'center' }}>{row.sn}</td>
                                <td style={{ textAlign: 'left' }}>{row.productName}</td>
                                <td style={{ textAlign: 'center' }}>{row.qty}</td>
                                <td style={{ textAlign: 'right' }}>{row.rate}</td>
                                <td style={{ textAlign: 'center' }}>{row.unitName}</td>
                                <td style={{ textAlign: 'right' }}>{row.amount}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ textAlign: 'right', }} colSpan={2}><strong>Total</strong></td>
                            <td style={{ textAlign: 'center', }}><span>{totalQty}</span></td>
                            <td colSpan={3} style={{ textAlign: 'right', }}><span>{amountData}</span></td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', }} colSpan={6}>
                                <span> In Words: </span>  {currencyName} {amountInWords}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A', marginTop: "10px", marginBottom: "10px" }}
                >
                    <thead style={{
                        textAlign: 'left',

                    }} >
                        <tr>
                            <th colSpan={6}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontWeight: "500" }}>
                                    <div><span>Payment Type:</span> {paymentMethodName}</div>
                                    <div><span>POL:</span> {portOfLoading}</div>
                                    <div><span>POD:</span> {portOfDestination}</div>
                                    <div><span></span> </div>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th colSpan={6}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontWeight: "500" }}>
                                    {advance ? <div><span>advance :</span> {advance}</div> : null}
                                    {final ? <div><span>final :</span> {final}</div> : null}
                                    {paymentAgainstTitle ? <div><span>payment Against :</span> {paymentAgainstTitle}</div> : null}
                                    {creditDay ? <div><span>credit Day :</span> {creditDay}</div> : null}
                                </div>
                            </th>
                        </tr>

                    </thead>
                </table>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginBottom: '10px', breakInside: "avoid" }}>
                    <div style={{ width: '70%' }}>
                        {manufacturerName?.trim() && (
                            <div style={{ fontSize: "8px", lineHeight: "1", marginBottom: "10px" }}>
                                <p style={{ margin: 1, fontSize: "10px" }}>
                                    Manufacturer Name:  {manufacturerName}
                                </p>
                            </div>
                        )}
                        <div style={{ fontSize: "8px", lineHeight: "1" }}>
                            <p style={{ margin: 1, fontSize: "10px" }}>
                                Terms and Conditions:
                            </p>
                            <div style={{ marginTop: "5px" }}>
                                <HtmlContentRenderer html={termConditions} />
                            </div>
                        </div>
                    </div>


                    <div style={{ width: '30%', textAlign: 'right' }}>
                        <p style={{ margin: 1 }}><strong>For {companyName}  </strong></p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>
                <div>
                    <table
                        border='1px solid black'
                        cellPadding="8"
                        cellSpacing="0"
                        style={{ width: '100%', fontSize: "12px", marginTop: "10px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                    >
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', }}>
                                    <span style={{ fontWeight: 500 }}>Beneficiary details</span>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {/* Left Side */}
                                        <div style={{ display: 'flex', width: '50%', flexDirection: 'column' }}>
                                            <span style={{ fontWeight: 500 }}>Beneficiary: {accountHolderName}</span>
                                            <span style={{ fontWeight: 500 }}>Bank Name: {bankName}</span>
                                            <span style={{ fontWeight: 500 }}>IBAN Number: {ibanNumber}</span>
                                        </div>

                                        {/* Right Side */}
                                        <div style={{ display: 'flex', width: '50%', flexDirection: 'column', textAlign: 'left' }}>
                                            <span style={{ fontWeight: 500 }}>Account No: {accountNumber}</span>
                                            <span style={{ fontWeight: 500 }}>Swift Code: {swiftCode}</span>
                                        </div>
                                    </div>
                                    <span style={{ fontWeight: 500 }}>Add: {bankAddress}, {countryName}</span>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>

                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>

            </div >
        </>

    );
};

const CommercialInvoiceContentSecond = ({ amountInWords, commercialInvoiceNo, invoiceData, totalQty, amountData, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const reference = invoiceData?.reference || "";
    const rawAdvance = invoiceData?.ProformaInvExp?.advance;
    const rawFinal = invoiceData?.ProformaInvExp?.final;
    const rawCreditDay = invoiceData?.ProformaInvExp?.creditDay;
    const paymentAgainstTitle = invoiceData?.ProformaInvExp?.paymentAgainst?.title || '';
    const manufacturerName = invoiceData?.manufacturerName || "";

    const advance = rawAdvance ? `${rawAdvance}%` : '';
    const final = rawFinal ? `${rawFinal}%` : '';
    const creditDay = rawCreditDay ? `${rawCreditDay} Day` : '';

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const ibanNumber = companyBanks?.ibanNumber || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        qty: particular.qty || 0,
        amounts: particular.amount || 0,
        description: particular.description || 0,
        rate: `${currencySymbol} ${parseFloat(particular.rate).toFixed(2)}`,
        amount: `${currencySymbol} ${parseFloat(particular.amount).toFixed(2)}`,
        // productName: particular.products.productName,
        unitName: particular.productsUnit.unitName,
        productName: (
            <div style={{ display: 'block', }}>
                <div>
                    {particular.products.productName || '-'}
                </div>

                {particular.products.iupac && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>IUPAC :</strong> {particular.products.iupac}
                    </div>
                )}

                {particular.products.casNo && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>CAS No :</strong> {particular.products.casNo}
                    </div>
                )}
            </div>
        ),

    }));

    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>{companyName}</p>
                        <p style={{ fontSize: '12px', margin: '0px 0 0px' }}>
                            {companyAddress && `${companyAddress},`}
                            {[companyCity, companyState, companyCountry].filter(Boolean).join(', ')}
                            {companyPincode && ` - ${companyPincode}`}
                        </p>
                        <p style={{ fontSize: '10px', margin: '0px 0 0px' }}>
                            Mobile: {companyMobile} | Email: {companyEmail} | Website:<a style={{ textTransform: "lowercase" }}> {companyWebsite}</a>
                        </p>
                        <p style={{ fontWeight: 'bold', fontSize: '14px', marginTop: 2, textTransform: "uppercase" }}>
                            Commercial Invoice
                        </p>
                    </div>
                </div>

                {/* Buyers and Sellers Info */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '60%', }}>
                        <p style={{ margin: 1 }}>
                            <span>Importer,</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <strong>{customerName}</strong>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>
                                {billingStreet && `${billingStreet},`}
                                <br />
                                {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                {billingPincode && ` - ${billingPincode}`}
                            </span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Email:</span> <span>{customerEmail}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Mobile:</span> <span>{customerMobile}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >IEC no:</span> <span>{iecNumber}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >GST no:</span> <span>{gstNumber}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >PAN no:</span> <span>{panNumber}</span>
                        </p>

                    </div>

                    <div style={{ width: '40%' }}>
                        <p style={{ margin: 1 }}>
                            <span>Commercial Invoice:</span> <span>{commercialInvoiceNo}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Date:</span> <span>{invoiceDate}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Order no:</span> <span> {reference}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Destination Port:</span> <span>{portOfDestination}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Loading Port:</span> <span>{portOfLoading}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Payment Type:</span> <span>{paymentMethodName}</span>
                        </p>
                        {/* Show these only if they have values */}
                        {advance && (
                            <p style={{ margin: 1 }}>
                                <span>Advance:</span> <span>{advance}</span>
                            </p>
                        )}
                        {final && (
                            <p style={{ margin: 1 }}>
                                <span>Final:</span> <span>{final}</span>
                            </p>
                        )}
                        {paymentAgainstTitle && (
                            <p style={{ margin: 1 }}>
                                <span>payment Against:</span> <span>{paymentAgainstTitle}</span>
                            </p>
                        )}
                        {creditDay && (
                            <p style={{ margin: 1 }}>
                                <span>Credit Day:</span> <span>{creditDay}</span>
                            </p>
                        )}


                    </div>
                </div>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead style={{ backgroundColor: "#ededed" }}>
                        <tr>
                            <th style={{ textAlign: 'center', width: "5%" }}>Sn.</th>
                            <th style={{ textAlign: 'center', width: "45%" }}>Commodity & description </th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "15%" }}>Rate</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Unit</th>
                            <th style={{ textAlign: 'center', width: "15%" }}>Amount</th>

                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'center' }}>{row.sn}</td>
                                <td style={{ textAlign: 'left' }}>{row.productName}</td>
                                <td style={{ textAlign: 'center' }}>{row.qty}</td>
                                <td style={{ textAlign: 'right' }}>{row.rate}</td>
                                <td style={{ textAlign: 'center' }}>{row.unitName}</td>
                                <td style={{ textAlign: 'right' }}>{row.amount}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ textAlign: 'right', }} colSpan={2}><strong>Total</strong></td>
                            <td style={{ textAlign: 'center', }}><span>{totalQty}</span></td>
                            <td colSpan={3} style={{ textAlign: 'right', }}><span>{amountData}</span></td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', }} colSpan={6}>
                                <span> In Words: </span>{currencyName} {amountInWords}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', breakInside: "avoid", marginTop: "5px", fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <tbody style={{ textTransform: "capitalize" }}>
                        <tr>
                            <td
                                rowSpan={2} style={{
                                    verticalAlign: 'top',
                                    padding: '8px',
                                    width: '60%'
                                }}
                            >
                                {manufacturerName?.trim() && (
                                    <div style={{ marginBottom: "8px" }}>
                                        <p
                                            style={{
                                                margin: 0,
                                                fontSize: "12px",

                                            }}
                                        >
                                            Manufacturer Name:{manufacturerName}
                                        </p>

                                    </div>
                                )}

                                <div style={{ fontSize: "10px", lineHeight: "1.4" }}>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",

                                            marginBottom: "5px"
                                        }}
                                    >
                                        Terms and Conditions:
                                    </p>

                                    <div style={{ marginTop: "5px" }}>
                                        <HtmlContentRenderer html={termConditions} />
                                    </div>
                                </div>
                            </td>


                            <td style={{ textAlign: 'left', verticalAlign: 'top', width: '40%' }}>
                                <p style={{ margin: 1 }}><span>Beneficiary Details:</span></p>
                                <p style={{ margin: 1 }}><span>Beneficiary:</span> <span>{accountHolderName}</span></p>
                                <p style={{ margin: 1 }}><span>Bank Name:</span> <span>{bankName}</span></p>
                                <p style={{ margin: 1 }}><span>Account no:</span> <span>{accountNumber}</span></p>
                                <p style={{ margin: 1 }}><span>Swift Code:</span> <span>{swiftCode}</span></p>
                                <p style={{ margin: 1 }}><span>IBAN Number:</span> <span>{ibanNumber}</span></p>
                                <p style={{ margin: 1 }}><span>Bank Address:</span> <span>{bankAddress}, {countryName} </span></p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', verticalAlign: 'top', width: '40%' }}>
                                <p style={{ margin: 1 }}><strong>For {companyName}</strong></p>
                                <Box
                                    component="img"
                                    src={Signature}

                                    style={{
                                        maxWidth: '100px',
                                        width: '100%',
                                        height: Signature ? 'auto' : '100px',
                                        marginBottom: 1
                                    }}
                                />
                                <p style={{ margin: 1 }}>Authorized Signatory</p>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>

            </div >
        </>

    );
};


const CommercialInvoiceContentThird = ({ amountInWords, commercialInvoiceNo, shippingmark, invoiceData, totalQty, amountData, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    const reference = invoiceData?.reference || "";
    const manufacturerName = invoiceData?.manufacturerName || "";

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const ibanNumber = companyBanks?.ibanNumber || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    const rawAdvance = invoiceData?.ProformaInvExp?.advance;
    const rawFinal = invoiceData?.ProformaInvExp?.final;
    const rawCreditDay = invoiceData?.ProformaInvExp?.creditDay;
    const paymentAgainstTitle = invoiceData?.ProformaInvExp?.paymentAgainst?.title || '';

    const advance = rawAdvance ? `${rawAdvance}%` : '';
    const final = rawFinal ? `${rawFinal}%` : '';
    const creditDay = rawCreditDay ? `${rawCreditDay} Day` : '';

    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        qty: particular.qty || 0,
        amounts: particular.amount || 0,
        description: particular.description || 0,
        rate: `${currencySymbol} ${parseFloat(particular.rate).toFixed(2)}`,
        amount: `${currencySymbol} ${parseFloat(particular.amount).toFixed(2)}`,
        // productName: particular.products.productName,
        unitName: particular.productsUnit.unitName,
        productName: (
            <div style={{ display: 'block', }}>
                <div>
                    {particular.products.productName || '-'}
                </div>

                {particular.products.iupac && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>IUPAC :</strong> {particular.products.iupac}
                    </div>
                )}

                {particular.products.casNo && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>CAS No :</strong> {particular.products.casNo}
                    </div>
                )}
            </div>
        ),

    }));

    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>{companyName}</p>
                        <p style={{ fontSize: '12px', margin: '0px 0 0px' }}>
                            {companyAddress && `${companyAddress},`}
                            {[companyCity, companyState, companyCountry].filter(Boolean).join(', ')}
                            {companyPincode && ` - ${companyPincode}`}
                        </p>
                        <p style={{ fontSize: '10px', margin: '0px 0 0px' }}>
                            Mobile: {companyMobile} | Email: {companyEmail} | Website:<a style={{ textTransform: "lowercase" }}> {companyWebsite}</a>
                        </p>
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>
                            Commercial Invoice
                        </p>
                    </div>
                </div>

                {/* Buyers and Sellers Info */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '60%', }}>
                        <p style={{ margin: 1 }}>
                            <span>Buyer,</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <strong>{customerName}</strong>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>
                                {billingStreet && `${billingStreet},`}
                                <br />
                                {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                {billingPincode && ` - ${billingPincode}`}
                            </span>

                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Email:</span> <span>{customerEmail}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >Mobile:</span> <span>{customerMobile}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >IEC no:</span> <span>{iecNumber}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >GST no:</span> <span>{gstNumber}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span >PAN no:</span> <span>{panNumber}</span>
                        </p>

                    </div>

                    <div style={{ width: '40%' }}>
                        <p style={{ margin: 1 }}>
                            <span>Commercial Invoice:</span> <span>{commercialInvoiceNo}</span>
                        </p>

                        <p style={{ margin: 1 }}>
                            <span>Date:</span> <span>{invoiceDate}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>order no:</span> <span>{reference} </span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Destination Port:</span> <span>{portOfDestination}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Loading Port:</span> <span>{portOfLoading}</span>
                        </p>
                        <p style={{ margin: 1 }}>
                            <span>Payment Type:</span> <span>{paymentMethodName}</span>
                        </p>
                        {advance && (
                            <p style={{ margin: 1 }}>
                                <span>Advance:</span> <span>{advance}</span>
                            </p>
                        )}
                        {final && (
                            <p style={{ margin: 1 }}>
                                <span>Final:</span> <span>{final}</span>
                            </p>
                        )}
                        {paymentAgainstTitle && (
                            <p style={{ margin: 1 }}>
                                <span>payment Against:</span> <span>{paymentAgainstTitle}</span>
                            </p>
                        )}
                        {creditDay && (
                            <p style={{ margin: 1 }}>
                                <span>Credit Day:</span> <span>{creditDay}</span>
                            </p>
                        )}

                    </div>
                </div>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead style={{ backgroundColor: "#ededed" }}>
                        <tr>
                            <th style={{ textAlign: 'center', width: "30%" }}>shipping mark</th>
                            <th style={{ textAlign: 'center', width: "30%" }}>Commodity & description </th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Rate</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Unit</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Amount</th>

                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                {index === 0 && (
                                    <td rowSpan={particularData.length} style={{ verticalAlign: 'top', padding: '8px' }}>
                                        <div><span>{productName}</span> </div>
                                        <br />
                                        <div> <HtmlContentRenderer html={invoiceShippingmark} /></div>
                                        <div> <span>Batch No:</span> {batchNo}</div>
                                        <br />
                                    </td>
                                )}
                                <td style={{ textAlign: 'left' }}>{row.productName}</td>
                                <td style={{ textAlign: 'center' }}>{row.qty}</td>
                                <td style={{ textAlign: 'right' }}>{row.rate}</td>
                                <td style={{ textAlign: 'center' }}>{row.unitName}</td>
                                <td style={{ textAlign: 'right' }}>{row.amount}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ textAlign: 'right', }} colSpan={2}><strong>Total</strong></td>
                            <td style={{ textAlign: 'center', }}><span>{totalQty}</span></td>
                            <td colSpan={3} style={{ textAlign: 'right', }}><span>{amountData}</span></td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', }} colSpan={6}>
                                <span> In Words: </span>  {currencyName} {amountInWords}
                            </td>
                        </tr>
                    </tbody>
                </table>


                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginBottom: '10px', breakInside: "avoid" }}>

                    <div style={{ width: '70%' }}>
                        {manufacturerName?.trim() && (
                            <div style={{ fontSize: "8px", lineHeight: "1", marginBottom: "10px" }}>
                                <p style={{ margin: 1, fontSize: "10px" }}>
                                    Manufacturer Name:  {manufacturerName}
                                </p>
                            </div>
                        )}
                        <div style={{ fontSize: "8px", lineHeight: "1" }}>
                            <p style={{ margin: 1, fontSize: "10px" }}>
                                Terms and Conditions:
                            </p>
                            <div style={{ marginTop: "5px" }}>
                                <HtmlContentRenderer html={termConditions} />
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '30%', textAlign: 'right' }}>
                        <p style={{ margin: 1 }}><strong>For {companyName}  </strong></p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>
                <div>
                    <table
                        border='1px solid black'
                        cellPadding="8"
                        cellSpacing="0"
                        style={{ width: '100%', fontSize: "12px", marginTop: "10px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                    >
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', }}>
                                    <span style={{ fontWeight: 500 }}>Beneficiary details</span>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {/* Left Side */}
                                        <div style={{ display: 'flex', width: '50%', flexDirection: 'column' }}>
                                            <span style={{ fontWeight: 500 }}>Beneficiary: {accountHolderName}</span>
                                            <span style={{ fontWeight: 500 }}>Bank Name: {bankName}</span>
                                            <span style={{ fontWeight: 500 }}>IBAN Number: {ibanNumber}</span>
                                        </div>

                                        {/* Right Side */}
                                        <div style={{ display: 'flex', width: '50%', flexDirection: 'column', textAlign: 'left' }}>
                                            <span style={{ fontWeight: 500 }}>Account No: {accountNumber}</span>
                                            <span style={{ fontWeight: 500 }}>Swift Code: {swiftCode}</span>
                                        </div>
                                    </div>
                                    <span style={{ fontWeight: 500 }}>Add: {bankAddress}, {countryName}</span>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>

                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </div >
        </>

    );
};
const CommercialInvoiceContentFour = ({ amountInWords, commercialInvoiceNo, shippingmark, invoiceData, totalQty, amountData, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    const manufacturerName = invoiceData?.manufacturerName || '';
    const reference = invoiceData?.reference || "";
    const rawAdvance = invoiceData?.ProformaInvExp?.advance;
    const rawFinal = invoiceData?.ProformaInvExp?.final;
    const rawCreditDay = invoiceData?.ProformaInvExp?.creditDay;

    const advance = rawAdvance ? `${rawAdvance}%` : '';
    const final = rawFinal ? `${rawFinal}%` : '';
    const creditDay = rawCreditDay ? `${rawCreditDay} Day` : '';
    const paymentAgainstTitle = invoiceData?.ProformaInvExp?.paymentAgainst?.title || '';

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const ibanNumber = companyBanks?.ibanNumber || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        qty: particular.qty || 0,
        amounts: particular.amount || 0,
        description: particular.description || 0,
        rate: `${currencySymbol} ${parseFloat(particular.rate).toFixed(2)}`,
        amount: `${currencySymbol} ${parseFloat(particular.amount).toFixed(2)}`,
        // productName: particular.products.productName,
        unitName: particular.productsUnit.unitName,
        productName: (
            <div style={{ display: 'block', }}>
                <div>
                    {particular.products.productName || '-'}
                </div>

                {particular.products.iupac && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>IUPAC :</strong> {particular.products.iupac}
                    </div>
                )}

                {particular.products.casNo && (
                    <div style={{ fontSize: '10px' }}>
                        <strong>CAS No :</strong> {particular.products.casNo}
                    </div>
                )}
            </div>
        ),

    }));


    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: "10px"
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>{companyName}</p>
                        <p style={{ fontSize: '12px', margin: '0px 0 0px' }}>
                            {companyAddress && `${companyAddress},`}
                            {[companyCity, companyState, companyCountry].filter(Boolean).join(', ')}
                            {companyPincode && ` - ${companyPincode}`}
                        </p>
                        <p style={{ fontSize: '10px', margin: '0px 0 0px' }}>
                            Mobile: {companyMobile} | Email: {companyEmail} | Website:<a style={{ textTransform: "lowercase" }}> {companyWebsite}</a>
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'right',
                            alignItems: 'right',
                            textAlign: 'right',
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', }}>
                            <div style={{ height: '1px', backgroundColor: 'black', width: '100%' }} />
                            <div style={{ height: '1px', backgroundColor: 'black', width: '100%' }} />
                        </div>

                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: "20px"
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>
                            Commercial Invoice
                        </p>
                    </div>
                </div>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead style={{ textAlign: 'left', }} >

                        <tr>
                            <th colSpan={6}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>

                                    <div style={{ fontWeight: "500", width: "60%", }}>
                                        <p style={{ margin: 1 }}><span>to,</span></p>
                                        <p style={{ margin: 1 }}>
                                            <strong>{customerName}</strong>
                                        </p>
                                        <p style={{ margin: 1 }}>
                                            <span>
                                                {billingStreet && `${billingStreet},`}
                                                <br />
                                                {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                                {billingPincode && ` - ${billingPincode}`}
                                            </span>
                                        </p>
                                        <p style={{ margin: 1 }}>
                                            <span >Email:</span> <span>{customerEmail}</span>
                                        </p>
                                        <p style={{ margin: 1 }}>
                                            <span >Mobile:</span> <span>{customerMobile}</span>
                                        </p>
                                    </div>

                                    <div style={{ fontWeight: "500", width: "40%", }}>
                                        <p style={{ margin: 1 }}>
                                            <span >IEC No:</span> <span>{iecNumber}</span>
                                        </p>
                                        <p style={{ margin: 1 }}>
                                            <span >GST No:</span> <span>{gstNumber}</span>
                                        </p>
                                        <p style={{ margin: 1 }}>
                                            <span >PAN No:</span> <span>{panNumber}</span>
                                        </p>
                                    </div>
                                </div>
                            </th>
                        </tr>

                        <tr style={{ backgroundColor: "#ededed", }} >
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>Date</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>Invoice</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>Order no</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>POL</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>POD</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>payment</th>
                        </tr>
                        <tr>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>{invoiceDate}</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>{commercialInvoiceNo}</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}> {reference}</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>{portOfLoading}</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>{portOfDestination}</th>
                            <th style={{ textAlign: 'center', fontWeight: "500", textTransform: "uppercase" }}>{paymentMethodName}</th>
                        </tr>
                        <tr style={{ backgroundColor: "#ededed", }} >
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>advance</th>
                            <th style={{ textAlign: 'center', fontWeight: "500" }}>final</th>
                            <th colSpan={2} style={{ textAlign: 'center', fontWeight: "500" }}>payment Against</th>
                            <th colSpan={2} style={{ textAlign: 'center', fontWeight: "500" }}>creditDay</th>
                        </tr>
                        <tr>
                            {advance && (
                                <th style={{ textAlign: 'center', fontWeight: "500" }}>{advance}</th>
                            )}
                            {final && (
                                <th style={{ textAlign: 'center', fontWeight: "500" }}>{final}</th>
                            )}
                            {paymentAgainstTitle && (
                                <th colSpan={2} style={{ textAlign: 'center', fontWeight: "500" }}>
                                    {paymentAgainstTitle}
                                </th>
                            )}
                            {creditDay && (
                                <th colSpan={2} style={{ textAlign: 'center', fontWeight: "500" }}>
                                    {creditDay}
                                </th>
                            )}
                        </tr>

                    </thead>
                    <thead  >
                        <tr style={{ backgroundColor: "#ededed" }}>
                            <th style={{ textAlign: 'center', width: "30%" }}>shipping mark</th>
                            <th style={{ textAlign: 'center', width: "30%" }}>Commodity & description </th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Rate</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Unit</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Amount</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                {index === 0 && (
                                    <td rowSpan={particularData.length} style={{ verticalAlign: 'top', padding: '8px' }}>
                                        <div><span>{productName}</span> </div>
                                        <br />
                                        <div> <HtmlContentRenderer html={invoiceShippingmark} /></div>
                                        <div> <span>Batch No:</span> {batchNo}</div>
                                        <br />
                                    </td>
                                )}
                                <td style={{ textAlign: 'left' }}>{row.productName}</td>
                                <td style={{ textAlign: 'center' }}>{row.qty}</td>
                                <td style={{ textAlign: 'right' }}>{row.rate}</td>
                                <td style={{ textAlign: 'center' }}>{row.unitName}</td>
                                <td style={{ textAlign: 'right' }}>{row.amount}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ textAlign: 'right', }} colSpan={2}><strong>Total</strong></td>
                            <td style={{ textAlign: 'center', }}><span>{totalQty}</span></td>
                            <td colSpan={3} style={{ textAlign: 'right', }}><span>{amountData}</span></td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', }} colSpan={6}>
                                <span> In Words: </span>{currencyName} {amountInWords}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', breakInside: "avoid", marginTop: "5px", fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <tbody style={{ textTransform: "capitalize" }}>
                        <tr>
                            <td
                                rowSpan={2} style={{
                                    verticalAlign: 'top',
                                    padding: '8px',
                                    width: '60%'
                                }}
                            >
                                {manufacturerName?.trim() && (
                                    <div style={{ marginBottom: "8px" }}>
                                        <p
                                            style={{
                                                margin: 0,
                                                fontSize: "12px",
                                            }}
                                        >
                                            Manufacturer Name:{manufacturerName}
                                        </p>

                                    </div>
                                )}

                                <div style={{ fontSize: "10px", lineHeight: "1.4" }}>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            marginBottom: "5px"
                                        }}
                                    >
                                        Terms and Conditions:
                                    </p>

                                    <div style={{ marginTop: "5px" }}>
                                        <HtmlContentRenderer html={termConditions} />
                                    </div>
                                </div>
                            </td>
                            <td style={{ textAlign: 'left', verticalAlign: 'top', width: '40%' }}>
                                <p style={{ margin: 1 }}><span>Beneficiary Details:</span></p>
                                <p style={{ margin: 1 }}><span>Beneficiary:</span> <span>{accountHolderName}</span></p>
                                <p style={{ margin: 1 }}><span>Bank Name:</span> <span>{bankName}</span></p>
                                <p style={{ margin: 1 }}><span>Account no:</span> <span>{accountNumber}</span></p>
                                <p style={{ margin: 1 }}><span>Swift Code:</span> <span>{swiftCode}</span></p>
                                <p style={{ margin: 1 }}><span>IBAN Number:</span> <span>{ibanNumber}</span></p>
                                <p style={{ margin: 1 }}><span>Bank Address:</span> <span>{bankAddress}, {countryName}</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', verticalAlign: 'top', width: '40%' }}>
                                <p style={{ margin: 1 }}><strong>For {companyName}</strong></p>
                                <Box
                                    component="img"
                                    src={Signature}
                                    style={{
                                        maxWidth: '100px',
                                        width: '100%',
                                        height: Signature ? 'auto' : '100px',
                                        marginBottom: 1
                                    }}
                                />
                                <p style={{ margin: 1 }}>Authorized Signatory</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </div >
        </>

    );
};


// Export both functions CommercialInvoice 
export {
    CommercialInvoiceContentFirst,
    CommercialInvoiceContentSecond,
    CommercialInvoiceContentThird,
    CommercialInvoiceContentFour
};
